import i18n from "@/plugins/vue-i18n";

const Trans = {
  get defaultLanguage() {
    return "zh_hant";
  },
  get supportedLanguages() {
    return ["zh_hant", "en", "zh_hans"];
  },
  get currentLanguage() {
    return i18n.locale;
  },
  set currentLanguage(lang) {
    i18n.locale = lang;
  },
  getInitialLanguage() {
    return document.querySelector("html").getAttribute("lang");
  },
  setI18nLanguage(lang) {
    Trans.currentLanguage = lang;

    document.querySelector("html").setAttribute("lang", lang);
    document.title = i18n.t("title");
    return lang;
  },
  changeLanguage(lang) {
    if (!Trans.supportedLanguages.includes(lang)) {
      lang = Trans.defaultLanguage;
    }

    return import(
      /* webpackChunkName: "lang/[request]" */ `@/lang/${lang}`
    ).then((messages) => {
      i18n.setLocaleMessage(lang, messages.default);
      return Trans.setI18nLanguage(lang);
    });
  },
};

export default Trans;
